import { CiCalendarDate } from "react-icons/ci";
import { IoSearchSharp } from "react-icons/io5";
import { MdPriorityHigh } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import erody from "../../../assets/erody_wink_body.svg";
import ResultInform from "../../../components/ResultInform/ResultInform";

import useSearchItems from "#features/LostFound/hooks/useSearchItems";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from "date-fns/locale";
import { forwardRef, useEffect } from "react";
import { formatDateMD } from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import useReactGASend from "../../../hooks/useReactGASend";
import useSelectBrand from "#hooks/styles/useSelectBrand";

const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <button
    className="relative flex items-center justify-between w-full font-medium bg-no-repeat rounded-lg input bg-neutral-100"
    onClick={onClick}
  >
    {value}

    <CiCalendarDate className="text-3xl text-neutral-500" />
  </button>
));

const Store = ({ branchName }) => {
  return (
    <>
      <div className="label">
        <span className="text-base font-semibold label-text">점포</span>
      </div>
      <div className="flex items-center h-12 pl-4 text-lg font-medium rounded-lg bg-neutral-100 text-neutral-400">
        {branchName}
      </div>
    </>
  );
};

const Duration = ({ formData, handleDateChange }) => {
  return (
    <div className="form-control w-full mt-2.5">
      <div className="label">
        <span className="flex items-center gap-2 text-base font-semibold label-text">
          기간
        </span>
      </div>
      <div className="flex items-center">
        <DatePicker
          selected={formData.startDay}
          name="startDay"
          onChange={(date) => handleDateChange(date, "startDay")}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInput />}
          locale={ko}
          minDate={formData.minDate}
          maxDate={formData.maxDate}
        />

        <span className="px-1.5"> - </span>
        <DatePicker
          selected={formData.endDay}
          name="endDay"
          onChange={(date) => handleDateChange(date, "endDay")}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInput />}
          locale={ko}
          minDate={formData.startDay || formData.minDate}
          maxDate={formData.maxDate}
        />
      </div>
    </div>
  );
};

const FoundItems = ({ handleChange, search, color }) => {
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      search();
    }
  };

  const handleOnClick = (e) => {
    search();
  };
  return (
    <label className="form-control w-full mt-2.5">
      <div className="label">
        <span className="flex items-center gap-2 text-base font-semibold label-text">
          습득내역
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <input
          name="itemName"
          type="text"
          placeholder="잃어버린 물품을 입력해주세요."
          className="w-full font-medium rounded-lg input bg-neutral-100"
          onChange={handleChange}
          autoComplete="off"
          onKeyDown={handleKeyPress}
        />
        <button
          type="submit"
          className={`flex items-center justify-center w-24 h-12 rounded-lg bg-${color}`}
          onClick={handleOnClick}
        >
          <IoSearchSharp className="text-2xl" />
        </button>
      </div>
    </label>
  );
};

const Inform = ({ color }) => {
  return (
    <div className={`p-6 mb-6 rounded-[20px] border border-${color}`}>
      <div className="flex items-center gap-4 mb-6 border-b border-neutral-400">
        <span className="h-[72px] overflow-hidden">
          <img src={erody} alt="마스코트" />
        </span>
        <h2 className="relative flex items-center justify-center grow bg-neutral-600 rounded-[20px] text-white font-bold py-2.5 ">
          <MdPriorityHigh />
          습득물품 주의사항
        </h2>
      </div>
      <ul className="flex flex-col gap-7">
        <li>
          <p className="mb-2 font-semibold">
            습득물품은 고객만족센터 보관 후 관할경찰서로 인계됩니다.
          </p>
          <ul className="text-sm font-medium text-neutral-500">
            <li className="flex gap-1 before:content-['•']">
              <p>구매물품 : 상품대금으로 일주일 간 보관</p>
            </li>
            <li className="flex gap-1 before:content-['•']">
              <p>개인물품 : 한달 간 보관, 식품류 습득 당일 폐기</p>
            </li>
            <li className="flex gap-1 before:content-['•']">
              <p>신분증, 현금(지갑포함), 귀중품 등 일주일 이내 인계</p>
            </li>
          </ul>
        </li>
        <li>
          <p className="mb-2 font-semibold">
            실시간 습득물 조회가 불가 할 수 있습니다.
          </p>
          <ul className="text-sm font-medium text-neutral-500 ">
            <li className="flex gap-1 before:content-['•']">
              <p>점포 담당자를 통한 전산등록 시점 이후 조회 가능</p>
            </li>
            <li className="flex gap-1 before:content-['•']">
              <p>점포 영업사정에 따라 전산등록 최대 1일 소요</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

const FindList = ({ list }) => {
  return (
    <>
      <div className="relative  mb-7 after:content-[''] after:absolute after:top-1/2 after:left-0 after:w-full after:h-px  after:bg-neutral-600">
        <h2 className="relative z-10 inline-flex font-semibold py-1.5 px-6 bg-neutral-600 rounded-[50px] text-white ">
          습득물 조회내역
        </h2>
      </div>{" "}
      <ul className="flex flex-col gap-1.5 mb-2.5">
        {list.map((item, index) => (
          <li
            key={index}
            className="flex justify-between p-5 rounded-[10px] border border-neutral-200"
          >
            <p className="w-3/12 font-medium text-neutral-500">
              {formatDateMD(item.find_date)}
            </p>

            <ul className="flex flex-col flex-1 font-semibold gap-y-1.5">
              <li>
                {item.sku_to_money_code === "02" ? (
                  <div>{item.sku_name}</div>
                ) : item.find_feature !== null ? (
                  <div>
                    {item.find_type_detail_name}({item.find_feature})
                  </div>
                ) : item.find_customer_info !== null ? (
                  <div>
                    {item.find_type_detail_name} ({item.find_feature}{" "}
                    {item.find_customer_info})
                  </div>
                ) : (
                  <div>{item.find_type_detail_name}</div>
                )}
              </li>
            </ul>
          </li>
        ))}
      </ul>
    </>
  );
};

const Registration = () => {
  const navigate = useNavigate();

  const { makeEventTrackFn } = useReactGASend();
  const trackLinkClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <button
      onClick={() => {
        navigate("/lost/found?agree=true");
        trackLinkClick("분실물등록(습득물조회페이지)");
      }}
      className="flex items-center justify-between w-full py-5 text-left text-white rounded-lg px-7 bg-purple-c-900"
    >
      <div className="flex flex-col">
        <p className="text-2xl">찾는 물품이 없나요?</p>
        <p className="text-sm font-bold">분실물 등록하러 가기</p>
      </div>
      <div className="flex items-center justify-center text-black bg-white rounded-full w-14 h-14">
        <IoIosArrowForward />
      </div>
    </button>
  );
};

const LostItemsSearch = ({ openModal, closeModal }) => {
  const location = useLocation();

  const {
    branchName,
    formData,
    handleChange,
    search,
    list,
    loaded,
    handleDateChange,
  } = useSearchItems();

  const { color } = useSelectBrand();

  useEffect(() => {
    const queryParams = queryString.parse(location.search);
    if (queryParams.agree) {
      openModal();
    } else {
      closeModal();
    }
  }, [location.search]);

  return (
    <>
      <div className="mb-10">
        <Store branchName={branchName} />

        <Duration formData={formData} handleDateChange={handleDateChange} />

        <FoundItems handleChange={handleChange} search={search} color={color} />
      </div>

      {loaded === null && <Inform color={color} />}

      {loaded === true && list?.length > 0 && (
        <>
          <FindList list={list} />
          <Inform color={color} />
          <Registration />
        </>
      )}

      {loaded === true && (list === null || list?.length === 0) && (
        <>
          <ResultInform
            label={
              <>
                검색 결과를 <br /> 찾을 수 없습니다.
              </>
            }
          />
          <Inform color={color} />

          <Registration />
        </>
      )}
    </>
  );
};

export default LostItemsSearch;
